var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.34433 10.8242H8.47656V12.668H9.34433V10.8242Z",
    fill: "#344767"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47657 8H6.59375V9.85788H7.47657V8Z",
    fill: "#344767"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75246 4.96879C9.55999 4.02761 10.136 1.90338 10.136 1.13444C10.136 -0.490034 9.16751 1.54855 7.97316 1.54855C6.77693 1.54855 5.81034 -0.51074 5.81034 1.13444C5.81034 1.91655 6.40234 4.09726 7.2334 5.01491C4.77881 5.71138 2.84375 9.24455 2.84375 12.3504C2.84375 15.0968 5.15434 15.5166 8.00328 15.5166C10.8522 15.5166 13.1619 15.0591 13.1619 12.3504C13.1619 9.52126 11.2758 5.57303 8.75246 4.96879ZM10.3854 12.7504H9.44422V13.6766H8.50304V14.6469H7.50351V13.6766H6.56234V12.7504L6.57457 12.7354H5.62116V11.7358H6.60657V12.6958L6.62163 12.677H7.50446V10.853H6.59151V9.92691H5.6061V7.9862H6.59151V7.02997H7.50351V6.05961H8.50304V7.02997H9.44422V7.97114H10.3703V8.97067H9.38493V8.00973L9.36987 8.01538H8.5021V9.8535H9.45834V10.8097H10.3845V12.7504H10.3854Z",
    fill: "#344767"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarBag);
export default __webpack_public_path__ + "static/media/dollarBag.405b8bb3abad672aa2c5b8fdffd91cf5.svg";
export { ForwardRef as ReactComponent };